<template>
  <el-card shadow="never" :class="iconClass">
    <h4 class="text-center">
      <i :class="`fa fa-building mr-2 ${iconClass}`"></i>
      {{ company.company_name }}
    </h4>
    <h6 class="text-center text-muted mb-3">{{ title }}</h6>
    
    <div class="mt-3 sub-details">
      <div class="d-flex align-items-center mb-2">
        <i class="fa fa-industry mr-2"></i>
        <span>{{ company.industry || 'No industry specified' }}</span>
      </div>
      <div class="d-flex align-items-center mb-2">
        <i class="fa fa-globe mr-2"></i>
        <span>{{ company.primary_market || 'No market specified' }}</span>
      </div>
      <div class="d-flex align-items-center mb-2">
        <i class="fa fa-users mr-2"></i>
        <span>{{ company.leads_count || 0 }} Lead(s)</span>
      </div>
      <div class="d-flex align-items-center mb-2">
        <i class="fa fa-user-tie mr-2"></i>
        <span>{{ hubspotOwnerName }}</span>
      </div>
      <div class="d-flex align-items-center mb-2">
        <i class="fa fa-calendar mr-2"></i>
        <span>Created {{ formatDate(company.created_at) }}</span>
      </div>
    </div>
  </el-card>
</template>

<script>
import { Card } from "element-ui";
import moment from 'moment';

export default {
  name: "CompanyMergeCard",
  components: {
    [Card.name]: Card,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'text-primary'
    }
  },
  computed: {
    hubspotOwnerName() {
      // You can enhance this to show actual owner names if available
      return this.company.hubspot_owner_id ? 
        `Owner ID: ${this.company.hubspot_owner_id}` : 
        'No HubSpot owner assigned';
    }
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('MMM DD, YYYY') : 'N/A';
    }
  }
};
</script>

<style scoped>
.sub-details {
  font-size: 0.875rem;
}

.sub-details i {
  width: 16px;
  color: #6c757d;
}

.text-warning {
  color: #ffc107 !important;
}

.text-success {
  color: #28a745 !important;
}

.text-primary {
  color: #007bff !important;
}
</style>